import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead'

export default function EmailVerificationPage({ onBackToLogin }) {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh', width: '100%' }}>
      {/* Left panel — branding */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'primary.light',
          color: 'primary.contrastText',
          p: 4,
          minHeight: { xs: '40vh', md: 'auto' },
        }}
      >
        <Box
          component="img"
          src="/favicon/android-chrome-192x192.png"
          alt="Wyes logo"
          sx={{ width: 120, height: 120, mb: 3 }}
        />
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          {t('AUTH.LANDING_TITLE')}
        </Typography>
        <Typography variant="h6" sx={{ maxWidth: 400, textAlign: 'center', opacity: 0.85 }}>
          {t('AUTH.LANDING_SUBTITLE')}
        </Typography>
      </Box>

      {/* Right panel — verification message */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
        }}
      >
        <MarkEmailReadIcon sx={{ fontSize: 80, color: 'primary.main', mb: 3 }} />

        <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">
          {t('AUTH.VERIFY_EMAIL_TITLE')}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: 480, textAlign: 'center' }}>
          {t('AUTH.VERIFY_EMAIL_MESSAGE')}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: 480, textAlign: 'center' }}>
          {t('AUTH.VERIFY_EMAIL_INSTRUCTIONS')}
        </Typography>

        <Button variant="contained" size="large" onClick={onBackToLogin}>
          {t('AUTH.BACK_TO_LOGIN')}
        </Button>
      </Box>
    </Box>
  )
}
